import Box from '@mui/material/Box'
import styled from '@emotion/styled'
import { useRouter } from 'next/router'

import { maxContentWidth, indexPageMaxContentWidth } from 'config/theme'

const StyledLargeContentWrapper = styled(Box)`
  ${({
    theme,
    $xs,
    $lg,
    $xl,
    $xxl,
    $widthLimit,
    $isServicePage,
    $isHomePage,
  }) => `
    width: 100%;
    max-width: ${
      $widthLimit
        ? $isHomePage
          ? indexPageMaxContentWidth
          : maxContentWidth
        : 'none'
    };
    margin-left: auto;
    margin-right: auto;

    padding-left: ${
      $isServicePage ? theme.spacing(0) : theme.spacing($xs ? 4 : 0)
    };
    padding-right: ${
      $isServicePage ? theme.spacing(0) : theme.spacing($xs ? 4 : 0)
    };

    ${
      $isHomePage
        ? `
        padding-left: ${theme.spacing($xs ? 4 : 0)};
        padding-right: ${theme.spacing($xs ? 4 : 0)};

        ${theme.breakpoints.up('md')} {
          padding-left: ${theme.spacing(8)};
          padding-right: ${theme.spacing(8)};
        }

        ${theme.breakpoints.up('xl')} {
          padding-left: ${theme.spacing($xl ? 12 : 0)};
          padding-right: ${theme.spacing($xl ? 12 : 0)};
          border-radius: 24px;
        }
      `
        : `
        ${theme.breakpoints.up('lg')} {
          padding-left: ${
            $isServicePage ? theme.spacing(0) : theme.spacing($lg ? 9 : 0)
          };
          padding-right: ${
            $isServicePage ? theme.spacing(0) : theme.spacing($lg ? 9 : 0)
          };
        }

        ${theme.breakpoints.up('xl')} {
          padding-left: ${
            $isServicePage ? theme.spacing(0) : theme.spacing($xl ? 12 : 0)
          };
          padding-right: ${
            $isServicePage ? theme.spacing(0) : theme.spacing($xl ? 12 : 0)
          };
        }

        ${theme.breakpoints.up('xxl')} {
          padding-left: ${
            $isServicePage ? theme.spacing(0) : theme.spacing($xxl ? 16 : 0)
          };
          padding-right: ${
            $isServicePage ? theme.spacing(0) : theme.spacing($xxl ? 16 : 0)
          };
        }
      `
    }
  `}
`

export const LargeContentWrapper = (props) => {
  const router = useRouter()
  const isHomePage = router.pathname === '/'

  return <StyledLargeContentWrapper {...props} $isHomePage={isHomePage} />
}

const StyledMediumContentWrapper = styled(Box)`
  ${({ theme, $xs, $lg, $xl, $xxl, $isServicePage, $isHomePage }) => `
    width: 100%;
    max-width: ${$isHomePage ? indexPageMaxContentWidth : maxContentWidth};
    margin-left: auto;
    margin-right: auto;

    padding-left: ${
      $isServicePage ? theme.spacing(0) : theme.spacing($xs ? 4 : 0)
    };
    padding-right: ${
      $isServicePage ? theme.spacing(0) : theme.spacing($xs ? 4 : 0)
    };

    ${
      $isHomePage
        ? `
        ${theme.breakpoints.up('md')} {
          padding-left: ${$isServicePage ? theme.spacing(0) : theme.spacing(8)};
          padding-right: ${
            $isServicePage ? theme.spacing(0) : theme.spacing(8)
          };
        }

        ${theme.breakpoints.up('xl')} {
          padding-left: ${
            $isServicePage ? theme.spacing(0) : theme.spacing($xl ? 12 : 0)
          };
          padding-right: ${
            $isServicePage ? theme.spacing(0) : theme.spacing($xl ? 12 : 0)
          };
        }
      `
        : `
        ${theme.breakpoints.up('lg')} {
          padding-left: ${
            $isServicePage ? theme.spacing(0) : theme.spacing($lg ? 9 : 0)
          };
          padding-right: ${
            $isServicePage ? theme.spacing(0) : theme.spacing($lg ? 9 : 0)
          };
        }

        ${theme.breakpoints.up('xl')} {
          padding-left: ${
            $isServicePage ? theme.spacing(0) : theme.spacing($xl ? 12 : 0)
          };
          padding-right: ${
            $isServicePage ? theme.spacing(0) : theme.spacing($xl ? 12 : 0)
          };
        }

        ${theme.breakpoints.up('xxl')} {
          padding-left: ${
            $isServicePage ? theme.spacing(0) : theme.spacing($xxl ? 16 : 0)
          };
          padding-right: ${
            $isServicePage ? theme.spacing(0) : theme.spacing($xxl ? 16 : 0)
          };
        }
      `
    }
  `}
`

export const MediumContentWrapper = (props) => {
  const router = useRouter()
  const isHomePage = router.pathname === '/'

  return <StyledMediumContentWrapper {...props} $isHomePage={isHomePage} />
}

const StyledMediumContentWrapperWithoutPadding = styled(Box)`
  ${({ $isHomePage }) => `
    width: 100%;
    max-width: ${$isHomePage ? indexPageMaxContentWidth : maxContentWidth};
    margin-left: auto;
    margin-right: auto;
    padding: 0;
  `}
`

export const MediumContentWrapperWithoutPadding = (props) => {
  const router = useRouter()
  const isHomePage = router.pathname === '/'

  return (
    <StyledMediumContentWrapperWithoutPadding
      {...props}
      $isHomePage={isHomePage}
    />
  )
}

LargeContentWrapper.defaultProps = {
  $xs: true,
  $lg: true,
  $xl: true,
  $xxl: true,
  $widthLimit: true,
  $isServicePage: false,
}

MediumContentWrapper.defaultProps = {
  $xs: true,
  $lg: true,
  $xl: true,
  $xxl: true,
  $isServicePage: false,
}
